import React from 'react'
import styled from 'styled-components'
import tw from 'tailwind.macro'
import {
  Heading,
  Wrapper,
  SubHeading,
  Paragraph,
  Head,
  Button,
} from '@/shared/styled'
import DwarvesIllustration from '@/components/svg/DwarvesIllustration'
import showApplyPopup from '@/components/showApplyPopup'

const Box = styled.div`
  background-color: ${props => props.theme.greyLighter};
  border-radius: 20px;
  ${tw`sm:py-20 sm:px-12 px-10 py-18 text-center`}
`

const Container = styled.div`
  max-width: 570px;
  margin: auto;
`

const ApplySection = () => {
  return (
    <section className="py-24 mb-10" id="how-to-apply">
      <Wrapper>
        <Box>
          <Container>
            <Heading>How To Apply</Heading>
            <Paragraph className="mb-12 mt-5">
              This{' '}
              <b className="font-semibold">30-minute pre-assessment test</b>{' '}
              below will helps us to select the suitable scouts for our training
              camp. Please be well noted that only shortlisted candidates will
              be contact for further details.
            </Paragraph>

            {/* <Button onClick={showApplyPopup()} className="apply-btn">
              Start now
            </Button> */}
            <Button className="apply-btn" disabled>
              Start now
            </Button>
          </Container>
        </Box>

        <div className="pt-1 mt-24 text-center">
          <div className="m-auto" style={{ maxWidth: '448px' }}>
            <DwarvesIllustration width={'100%'} />
          </div>
          <SubHeading className="mt-8">
            We look forward to having you at our woodland.{' '}
          </SubHeading>
        </div>
      </Wrapper>
    </section>
  )
}

export default ApplySection
